var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_10301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.975 10.8052V14.928H13.5847V11.0815C13.5847 10.1157 13.2396 9.45615 12.3741 9.45615C11.7137 9.45615 11.3213 9.9002 11.1481 10.3302C11.0851 10.4838 11.0689 10.6972 11.0689 10.9127V14.9278H8.67845C8.67845 14.9278 8.71054 8.41316 8.67845 7.7388H11.0691V8.75755C11.0643 8.76558 11.0575 8.77342 11.0532 8.78109H11.0691V8.75755C11.3867 8.26877 11.9533 7.56999 13.2234 7.56999C14.796 7.56999 15.975 8.59748 15.975 10.8052ZM6.17783 4.27344C5.36015 4.27344 4.8252 4.81018 4.8252 5.51537C4.8252 6.20559 5.34464 6.75784 6.14645 6.75784H6.16196C6.99568 6.75784 7.51406 6.20559 7.51406 5.51537C7.4982 4.81018 6.99568 4.27344 6.17783 4.27344ZM4.96727 14.928H7.35684V7.7388H4.96727V14.928Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_10301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdinIcon.f9337daffd2214764b0b97ae65ec2c8c.svg";
export { ForwardRef as ReactComponent };